import React from 'react';

function Credentials({ credentials }) {
  return (
    <section className="portfolioSection sectionReveal" id="credentials">
      <div className="portfolioSection__heading">
        <span className="portfolioEyebrow">Credentials</span>
        <h2>Certifications</h2>
      </div>

      <div className="portfolioCredentials">
        {credentials.map((credential) => (
          <article className="portfolioCredential" key={`${credential.provider}-${credential.title}`}>
            <img src={credential.image} alt={`${credential.title} certification`} loading="lazy" />
            <div>
              <span>{credential.category}</span>
              <h3>{credential.title}</h3>
              <p>{credential.provider}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Credentials;
